export const JOB_STATE_STARTED = 'STARTED' as const;
export const JOB_STATE_PROCESSING = 'PROCESSING' as const;
export const JOB_STATE_DONE = 'DONE' as const;
export const JOB_STATE_ERROR = 'ERROR' as const;
export const JOB_STATE_FAILED = 'FAILED' as const;
export const JOB_STATE_CREATED = 'CREATED' as const;
export const JOB_STATE_INTERRUPTED = 'INTERRUPTED' as const;
export const JOB_STATE_READY = 'READY' as const;

export const JOB_TYPE_TITLES = 'AUTO_TITLE' as const;
export const JOB_TYPE_SLIDES = 'VIDEO_SLIDES_PROCESSING' as const;
export const JOB_TYPE_DESCRIPTIONS = 'DESCRIPTIONS' as const;
export const JOB_TYPE_CHAPTERS = 'AUTO_CHAPTERS' as const;
export const JOB_TYPE_HIGHLIGHTS = 'VIDEO_HIGHLIGHTS_PROCESSING' as const;
export const JOB_TYPE_ASPECT_RATIOS = 'ASPECT_RATIO_VIDEO_DRAFT_PROCESSING' as const;
export const JOB_TYPE_ASPECT_RATIO_VIDEO_CREATING = 'ASPECT_RATIO_VIDEO_CREATING' as const;

export const JOB_TYPE_VIDEO_SLIDES_PDF_PROCESSING = 'VIDEO_SLIDES_PDF_PROCESSING' as const;
export const JOB_TYPE_THUMBNAIL_PROCESSING = 'THUMBNAIL_PROCESSING' as const;
export const JOB_TYPE_THUMBNAILS_CURRENT_FRAME_PROCESSING = 'THUMBNAILS_CURRENT_FRAME_PROCESSING' as const;
export const JOB_TYPE_THUMBNAILS_PUBLISHING = 'THUMBNAILS_PUBLISHING' as const;

export const JOB_TYPE_CC_TRANSLATION_PROCESSING = 'CC_TRANSLATION_PROCESSING' as const;
export const JOB_TYPE_SPEECH_RECOGNITION = 'SPEECH_RECOGNITION' as const;
export const JOB_TYPE_PUBLISH_TRANSCRIPT = 'PUBLISH_VIDEO_TRANSCRIPT' as const;
export const JOB_TYPE_CLOSED_CAPTIONS = 'CLOSED_CAPTIONS' as const;

export const JOB_TYPE_TAGGING = 'TAGGING' as const;
export const JOB_TYPE_SCENE_RECOGNITION = 'SCENE_RECOGNITION' as const;
export const JOB_TYPE_VIDEO_ENCODING = 'VIDEO_ENCODING' as const;
export const JOB_TYPE_VIDEO_PROCESSING = 'VIDEO_PROCESSING' as const;
export const JOB_TYPE_VIDEO_CHILD_PROCESSING = 'VIDEO_CHILD_PROCESSING' as const;
export const JOB_TYPE_VIDEO_VERSIONING = 'VIDEO_VERSIONING' as const;

export const ALLOWED_FILTER_JOB_TYPES = [
  JOB_TYPE_TITLES,
  JOB_TYPE_SLIDES,
  JOB_TYPE_DESCRIPTIONS,
  JOB_TYPE_CHAPTERS,
  JOB_TYPE_HIGHLIGHTS,
  JOB_TYPE_ASPECT_RATIOS,
  JOB_TYPE_ASPECT_RATIO_VIDEO_CREATING,

  JOB_TYPE_VIDEO_SLIDES_PDF_PROCESSING,
  JOB_TYPE_THUMBNAIL_PROCESSING,
  JOB_TYPE_THUMBNAILS_CURRENT_FRAME_PROCESSING,
  JOB_TYPE_THUMBNAILS_PUBLISHING,

  JOB_TYPE_CC_TRANSLATION_PROCESSING,
  JOB_TYPE_SPEECH_RECOGNITION,
  JOB_TYPE_PUBLISH_TRANSCRIPT,
  JOB_TYPE_CLOSED_CAPTIONS,

  JOB_TYPE_TAGGING,
  JOB_TYPE_SCENE_RECOGNITION,
  JOB_TYPE_VIDEO_ENCODING,
  JOB_TYPE_VIDEO_PROCESSING,
  JOB_TYPE_VIDEO_CHILD_PROCESSING,
  JOB_TYPE_VIDEO_VERSIONING,
];

export const BULK_ACTIONS_UPDATE_PROMOTIONS = 'BULK_ACTIONS_UPDATE_PROMOTIONS' as const;
export const BULK_ACTIONS_ARCHIVE = 'BULK_ACTIONS_ARCHIVE' as const;
export const BULK_ACTIONS_ADD_TAGS = 'BULK_ACTIONS_ADD_TAGS' as const;
export const BULK_ACTIONS_REPLACE_TAGS = 'BULK_ACTIONS_REPLACE_TAGS' as const;
export const BULK_ACTIONS_REPLACE_SITES = 'BULK_ACTIONS_REPLACE_SITES' as const;
export const BULK_ACTIONS_SHARE_WITH_USERS = 'BULK_ACTIONS_SHARE_WITH_USERS' as const;
export const BULK_ACTIONS_SHARE_ACCESS_LEVEL = 'BULK_ACTIONS_SHARE_ACCESS_LEVEL' as const;
